<div [ngClass]="{'mr-2': !noSpaces()}" class="inline-flex">
  @if (isCreate) {
  <app-icon name="heroPlus"></app-icon>
  } @else {
  <ng-content select="[icon]"></ng-content>
  }
</div>
<ng-content></ng-content>
